import { lazy } from 'react';

export const AsyncAdminRedirect = lazy(() => import('./AdminRedirect'));
export const AsyncCreateAccount = lazy(() => import('./CreateAccount'));
export const AsyncDashboard = lazy(() => import('./Dashboard'));
export const AsyncHome = lazy(() => import('./Home'));
export const AsyncHomeAuthenticated = lazy(() => import('./HomeAuthenticated'));
export const AsyncLogin = lazy(() => import('./Login'));
export const AsyncLogout = lazy(() => import('./Logout'));
export const AsyncNotFound = lazy(() => import('./NotFound'));
export const AsyncPasswordReset = lazy(() => import('./PasswordReset'));
export const AsyncSetPassword = lazy(() => import('./SetPassword'));
export const AsyncUser = lazy(() => import('./Settings'));

export const AsyncBookingList = lazy(() => import('../containers/BookingList'));
export const AsyncOffersList = lazy(() => import('../containers/OffersList'));
